import { createContext, useContext } from 'react';

import noop from 'utils/noop';
import { RestQueryHookResult } from 'utils/hooks/api/useRestQuery';
import { BehaviorMetric, BehaviorQuery, RawBehaviorQuery } from '../../domain';

type BehaviorRefetch = RestQueryHookResult<RawBehaviorQuery>['refetch'];

export type BehaviorQueryState = BehaviorQuery & {
  behaviorError: unknown;
  isBehaviorError: boolean;
  isBehaviorLoading: boolean;
  behavior: BehaviorQuery;
  refetchBehavior: BehaviorRefetch;
};

const defaultMetric: BehaviorMetric = { value: 0 };

export const behaviorQueryDefaultState = {
  isBehaviorError: false,
  behaviorError: null,
  isBehaviorLoading: false,
  behavior: {},
  totalPurchases: defaultMetric,
  conversionRate: defaultMetric,
  unsubscribeRate: defaultMetric,
  uniquePurchases: defaultMetric,
  revenue: defaultMetric,
  avgOrderValue: defaultMetric,
  refetchBehavior: noop as BehaviorRefetch,
};

export const BehaviorQueryContext = createContext<BehaviorQueryState>(behaviorQueryDefaultState);

export const useBehaviorQueryContext = () => useContext(BehaviorQueryContext);
